module.exports = __webpack_public_path__ + "static/media/white padding.3593b2e6.png";